import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getDataValueObjectFromDto } from '../utils/autoformUtils';
import useAutoformTableMetadata from './useAutoformTableMetadata';

const useAutoformTableData = (tableId) => {
    const data = useSelector((state) => state.autoform.tables[tableId] && state.autoform.tables[tableId].data);
    const { selectedItem: selectedItemId, primaryKeyColumnName } = useAutoformTableMetadata(tableId);

    const parsedData = useMemo(() => (data ? data.map(getDataValueObjectFromDto) : []), [data]);

    const selectedItem = useMemo(() => {
        return data?.find((record) => record[primaryKeyColumnName] === selectedItemId);
    }, [data, selectedItemId, primaryKeyColumnName]);

    return { data: parsedData, selectedItem };
};

export default useAutoformTableData;
